





































import Vue from "vue";
import RAMenu from "@/components/RAMenu.vue";
  
export default Vue.extend({
  name: "RAInternals",
  components: {
    RAMenu
  }
});
